
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","stroke":"currentColor","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M384 320V192c0-17.67-14.33-32-32-32h-36l-6.188-16.44C306.3 134.2 297.4 128 287.4 128h-62.8c-10 0-19 6.188-22.5 15.56L196 160h-36c-17.7 0-32 14.3-32 32v128c0 17.67 14.33 32 32 32h192c17.7 0 32-14.3 32-32zm-240 0V192c0-8.822 7.178-16 16-16h47.11l10-26.84c1.19-3.06 4.19-5.16 7.49-5.16h62.75c3.355 0 6.279 2.023 7.463 5.199L304.9 176H352c8.822 0 16 7.178 16 16v128c0 8.822-7.178 16-16 16H160c-8.8 0-16-7.2-16-16zm112-112c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 80c-17.6 0-32-14.4-32-32s14.36-32 32-32 32 14.36 32 32-14.4 32-32 32zM8 160c4.42 0 8-3.6 8-8V40c0-13.22 10.77-24 24-24h112c4.4 0 8-3.59 8-8s-3.6-8-8-8H40C17.94 0 0 17.94 0 40v112c0 4.4 3.578 8 8 8zM472 0H360c-4.4 0-8 3.594-8 8s3.578 8 8 8h112c13.23 0 24 10.78 24 24v112c0 4.4 3.6 8 8 8s8-3.6 8-8V40c0-22.06-17.9-40-40-40zm32 352c-4.422 0-8 3.594-8 8v112c0 13.22-10.77 24-24 24H360c-4.422 0-8 3.594-8 8s3.6 8 8 8h112c22.06 0 40-17.94 40-40V360c0-4.4-3.6-8-8-8zM152 496H40c-13.23 0-24-10.78-24-24V360c0-4.4-3.58-8-8-8s-8 3.6-8 8v112c0 22.1 17.94 40 40 40h112c4.4 0 8-3.6 8-8s-3.6-8-8-8z"}})])
          )
        }
      }
    